export default __webpack_public_path__ + "static/media/student_performance_icon.ff6aadbb.svg";